import { defineMessages } from 'react-intl';

export const freightRateCardMessages = defineMessages({
  standardLabel: {
    defaultMessage: 'Standard',
    id: 'LYaitY',
    description: 'Label for the standard (non-guaranteed) freight rate option',
  },
  guaranteedLabel: {
    defaultMessage: 'Guaranteed',
    id: 'VmgYRl',
    description: 'Label for the guaranteed freight rate option',
  },
  viewDetails: {
    defaultMessage: 'View Details',
    id: 'iOCdBc',
    description: 'Link to view full details for a carrier rate',
  },
  transitDays: {
    defaultMessage: '{days, plural, one {# day} other {# days}}',
    id: 'ZWvOn9',
    description: 'Transit time in days for a freight rate',
  },
  notAvailable: {
    defaultMessage: '{label} is not available',
    id: 'gw8RB+',
    description: 'Placeholder shown when a freight rate option (standard or guaranteed) is not offered by the carrier',
  },
});
